/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-sounds-fr block)");
/* eslint-enable no-console */

(function () {
    function init() {
        const ROOT = document.querySelector('.gba-wrap');
        if (!ROOT) return;

        const $ = id => document.getElementById(id);
        const $$ = sel => ROOT.querySelectorAll(sel);

        const EQ_BANDS = [
            { freq: 32, label: '32Hz' },
            { freq: 64, label: '64Hz' },
            { freq: 125, label: '125Hz' },
            { freq: 250, label: '250Hz' },
            { freq: 500, label: '500Hz' },
            { freq: 1000, label: '1kHz' },
            { freq: 2000, label: '2kHz' },
            { freq: 4000, label: '4kHz' },
            { freq: 8000, label: '8kHz' },
            { freq: 16000, label: '16kHz' },
        ];

        const EQ_PRESETS = {
            white: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            pink: [2, 3, 2, 1, 0, -1, -2, -3, -3, -4],
            brown: [5, 6, 5, 3, 0, -3, -5, -6, -7, -8],
            blue: [-3, -2, -1, 0, 1, 2, 3, 4, 5, 6],
            violet: [-5, -4, -2, 0, 2, 4, 5, 7, 8, 10],
            grey: [1, 1, 0, -1, -1, 0, 0, 1, 1, 1],
            static: [0, 0, 0, 0, 0, 0, 2, 3, 4, 5],
            red: [10, 9, 7, 4, 0, -5, -8, -10, -11, -12],
            orange: [7, 7, 5, 3, 1, -1, -3, -5, -7, -8],
            yellow: [4, 4, 3, 2, 1, 0, -1, -2, -3, -4],
            green: [0, 1, 1, 0, 0, 0, 0, -1, -1, -1],
            teal: [-1, -1, 0, 1, 2, 2, 1, 0, -1, -2],
            black: [12, 10, 6, 2, -3, -6, -9, -11, -12, -12],
            velvet: [1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
        };

        const NAMED_PRESETS = [
            { name: '🏢 Open-space', noise: 'white', volume: 50, eq: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
            { name: '😴 Sommeil profond', noise: 'pink', volume: 45, eq: [3, 4, 3, 2, 0, -2, -3, -4, -5, -6] },
            { name: '🤎 Sommeil lourd', noise: 'brown', volume: 55, eq: [6, 7, 5, 3, 0, -3, -5, -6, -7, -9] },
            { name: '👶 Pleurs bébé', noise: 'brown', volume: 65, eq: [8, 9, 7, 4, 0, -4, -6, -7, -8, -10] },
            { name: '🧠 Cognition', noise: 'blue', volume: 40, eq: [-2, -2, -1, 0, 1, 2, 3, 5, 6, 7] },
            { name: '⚡ Garder l\'éveil', noise: 'blue', volume: 50, eq: [-3, -3, -2, 0, 2, 3, 4, 6, 7, 8] },
            { name: '🎯 Concentration', noise: 'pink', volume: 42, eq: [2, 2, 1, 0, -1, -1, 0, 0, 0, -1] },
            { name: '🔇 Anti-acouphènes', noise: 'violet', volume: 35, eq: [-6, -5, -3, 0, 3, 5, 6, 8, 9, 10] },
            { name: '🎛️ Test audio', noise: 'grey', volume: 50, eq: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
            { name: '📺 ASMR rétro', noise: 'static', volume: 30, eq: [0, 0, 0, 0, 0, 1, 2, 4, 5, 6] },
            { name: '🧘 Méditation', noise: 'pink', volume: 38, eq: [5, 6, 4, 2, 0, -2, -3, -5, -6, -7] },
            { name: '🌿 Détente', noise: 'brown', volume: 60, eq: [7, 8, 6, 3, -1, -4, -6, -7, -8, -10] },
            { name: '🔴 Sommeil infra', noise: 'red', volume: 50, eq: [10, 9, 7, 4, 0, -5, -8, -10, -11, -12] },
            { name: '🟠 Chaleur douce', noise: 'orange', volume: 55, eq: [7, 7, 5, 3, 1, -1, -3, -5, -7, -8] },
            { name: '🟡 Ambiance café', noise: 'yellow', volume: 48, eq: [3, 4, 3, 2, 1, 0, -1, -2, -3, -4] },
            { name: '🟢 Sous-bois', noise: 'green', volume: 45, eq: [0, 1, 1, 0, 0, 0, 0, -1, -1, -1] },
            { name: '🫧 ASMR velours', noise: 'velvet', volume: 40, eq: [1, 1, 0, 0, 0, 0, 0, 0, 0, 0] },
        ];

        const NOISES = [
            {
                id: 'white', name: 'Blanc', emoji: '⬜', desc: 'Toutes fréquences égales',
                color: '#ffffff', bgColor: '#ffffff',
                generate(buf) { for (let i = 0; i < buf.length; i++)buf[i] = Math.random() * 2 - 1; }
            },
            {
                id: 'pink', name: 'Rose', emoji: '🌸', desc: 'Graves légèrement amplifiés',
                color: '#E91D62', bgColor: '#E91D62',
                generate(buf) {
                    let b0 = 0, b1 = 0, b2 = 0, b3 = 0, b4 = 0, b5 = 0, b6 = 0;
                    for (let i = 0; i < buf.length; i++) {
                        const w = Math.random() * 2 - 1;
                        b0 = .99886 * b0 + w * .0555179; b1 = .99332 * b1 + w * .0750759;
                        b2 = .96900 * b2 + w * .1538520; b3 = .86650 * b3 + w * .3104856;
                        b4 = .55000 * b4 + w * .5329522; b5 = -.7616 * b5 - w * .0168980;
                        buf[i] = (b0 + b1 + b2 + b3 + b4 + b5 + b6 + w * .5362) / 5.5; b6 = w * .115926;
                    }
                }
            },
            {
                id: 'brown', name: 'Brun', emoji: '🤎', desc: 'Graves très dominants',
                color: '#a0522d', bgColor: '#a0522d',
                generate(buf) {
                    let l = 0;
                    for (let i = 0; i < buf.length; i++) {
                        const w = Math.random() * 2 - 1; l = (l + .02 * w) / 1.02;
                        buf[i] = Math.max(-1, Math.min(1, l * 3.5));
                    }
                }
            },
            {
                id: 'blue', name: 'Bleu', emoji: '🔵', desc: 'Aigus amplifiés',
                color: '#0000FF', bgColor: '#0000ff',
                generate(buf) {
                    let l = 0;
                    for (let i = 0; i < buf.length; i++) {
                        const w = Math.random() * 2 - 1;
                        buf[i] = Math.max(-1, Math.min(1, (w - l) * .5)); l = w;
                    }
                }
            },
            {
                id: 'violet', name: 'Violet', emoji: '💜', desc: 'Très hautes fréquences',
                color: '#660099', bgColor: '#660099',
                generate(buf) {
                    let l = 0;
                    for (let i = 0; i < buf.length; i++) {
                        const w = Math.random() * 2 - 1; const d = w - l; l = w;
                        buf[i] = Math.max(-1, Math.min(1, d * .6));
                    }
                }
            },
            {
                id: 'grey', name: 'Gris', emoji: '🩶', desc: 'Équilibré perceptuellement',
                color: '#cfd8dc', bgColor: '#878787',
                generate(buf) {
                    let b0 = 0, b1 = 0, b2 = 0, b3 = 0, b4 = 0, b5 = 0, b6 = 0;
                    for (let i = 0; i < buf.length; i++) {
                        const w = Math.random() * 2 - 1;
                        b0 = .99886 * b0 + w * .0555179; b1 = .99332 * b1 + w * .0750759;
                        b2 = .96900 * b2 + w * .1538520; b3 = .86650 * b3 + w * .3104856;
                        b4 = .55000 * b4 + w * .5329522; b5 = -.7616 * b5 - w * .0168980;
                        const p = (b0 + b1 + b2 + b3 + b4 + b5 + b6 + w * .5362) / 5.5; b6 = w * .115926;
                        buf[i] = p * .8 + (Math.random() * 2 - 1) * .1;
                    }
                }
            },
            {
                id: 'static', name: 'Statique', emoji: '📺', desc: 'Friture TV analogique',
                color: '#616161', bgColor: '#616161',
                generate(buf) {
                    for (let i = 0; i < buf.length; i++)
                        buf[i] = Math.max(-1, Math.min(1, (Math.random() * 2 - 1) * .9 + (Math.random() > .98 ? (Math.random() * 2 - 1) * .5 : 0)));
                }
            },
            {
                id: 'red', name: 'Rouge', emoji: '🔴', desc: 'Ultra-graves, plus grave que le brun',
                color: '#ff0000', bgColor: '#ff0000',
                generate(buf) {
                    // 1/f³ : double intégration du bruit blanc
                    let l1 = 0, l2 = 0;
                    for (let i = 0; i < buf.length; i++) {
                        const w = Math.random() * 2 - 1;
                        l1 = (l1 + 0.04 * w) / 1.04;
                        l2 = (l2 + 0.04 * l1) / 1.04;
                        buf[i] = Math.max(-1, Math.min(1, l2 * 8));
                    }
                }
            },
            {
                id: 'orange', name: 'Orange', emoji: '🟠', desc: 'Graves chauds quasi-stationnaires',
                color: '#FF5C00', bgColor: '#FF5C00',
                generate(buf) {
                    // Bandes basses-médiums amplifiées (mélange brown + pink pondéré)
                    let l = 0, b0 = 0, b1 = 0, b2 = 0;
                    for (let i = 0; i < buf.length; i++) {
                        const w = Math.random() * 2 - 1;
                        l = (l + 0.035 * w) / 1.035;
                        b0 = 0.99 * b0 + w * 0.08;
                        b1 = 0.94 * b1 + w * 0.18;
                        b2 = 0.80 * b2 + w * 0.28;
                        buf[i] = Math.max(-1, Math.min(1, (l * 2 + b0 + b1 + b2) / 3.5));
                    }
                }
            },
            {
                id: 'yellow', name: 'Jaune', emoji: '🟡', desc: 'Médiums-bas chaleureux',
                color: '#ffd700', bgColor: '#ffd700',
                generate(buf) {
                    // Intermédiaire rose/blanc : légère pente -1.5 dB/oct
                    let b0 = 0, b1 = 0, b2 = 0, b3 = 0;
                    for (let i = 0; i < buf.length; i++) {
                        const w = Math.random() * 2 - 1;
                        b0 = 0.99 * b0 + w * 0.035;
                        b1 = 0.97 * b1 + w * 0.08;
                        b2 = 0.90 * b2 + w * 0.20;
                        b3 = 0.70 * b3 + w * 0.35;
                        buf[i] = Math.max(-1, Math.min(1, (b0 + b1 + b2 + b3 + w * 0.5) / 3.8));
                    }
                }
            },
            {
                id: 'green', name: 'Vert', emoji: '🟢', desc: 'Milieu du spectre, ambiance naturelle',
                color: '#008000', bgColor: '#008000',
                generate(buf) {
                    // Bande-passante centrée ~500 Hz : filtre passe-bande simulé
                    let lp = 0, hp = 0;
                    for (let i = 0; i < buf.length; i++) {
                        const w = Math.random() * 2 - 1;
                        lp = lp + 0.15 * (w - lp);   // passe-bas
                        hp = hp + 0.02 * (w - hp);   // composante très basse
                        buf[i] = Math.max(-1, Math.min(1, (lp - hp) * 2.2));
                    }
                }
            },
            {
                id: 'teal', name: 'Turquoise', emoji: '🩵', desc: 'Médiums-aigus équilibrés',
                color: '#00acc1', bgColor: '#00acc1',
                generate(buf) {
                    // Légère pente positive +1.5 dB/oct, moins agressif que bleu
                    let l = 0;
                    for (let i = 0; i < buf.length; i++) {
                        const w = Math.random() * 2 - 1;
                        const diff = (w - l) * 0.65;
                        buf[i] = Math.max(-1, Math.min(1, diff * 1.4));
                        l = l + 0.25 * (w - l);
                    }
                }
            },
            {
                id: 'black', name: 'Noir', emoji: '⬛', desc: 'Quasi-silence, ultra infra-graves',
                color: '#333333', bgColor: '#333333',
                generate(buf) {
                    // Intégration triple + gain très bas : spectre infra-sonique
                    let l1 = 0, l2 = 0, l3 = 0;
                    for (let i = 0; i < buf.length; i++) {
                        const w = Math.random() * 2 - 1;
                        l1 = (l1 + 0.02 * w) / 1.02;
                        l2 = (l2 + 0.02 * l1) / 1.02;
                        l3 = (l3 + 0.02 * l2) / 1.02;
                        buf[i] = Math.max(-1, Math.min(1, l3 * 20));
                    }
                }
            },
            {
                id: 'velvet', name: 'Velours', emoji: '🫧', desc: 'Impulsions rares, très doux',
                color: '#750851', bgColor: '#750851',
                generate(buf) {
                    // Velvet noise : ~1 impulsion / 16 samples, reste = silence
                    const density = Math.floor(buf.length / 16);
                    buf.fill(0);
                    for (let k = 0; k < density; k++) {
                        const pos = Math.floor(Math.random() * buf.length);
                        buf[pos] = (Math.random() > 0.5 ? 1 : -1) * (0.5 + Math.random() * 0.5);
                    }
                }
            },
        ];

        const BG_PRESETS = [
            { name: 'Noir', hex: '#111111' }, { name: 'Blanc', hex: '#f5f5f5' },
            { name: 'Rose', hex: '#f8bbd0' }, { name: 'Bleu ciel', hex: '#b3e5fc' },
            { name: 'Violet', hex: '#e1bee7' }, { name: 'Brun', hex: '#d7a97a' },
            { name: 'Gris', hex: '#cfd8dc' }, { name: 'Crème', hex: '#fff8e1' },
        ];

        // ── État ──────────────────────────────────────────────────────
        let audioCtx = null, gainNode = null, eqNodes = [], sourceNode = null, analyser = null;
        let playing = false, activeNamedPreset = null;
        let timerInterval = null, timerRemaining = 0;
        let mainVizRaf = null, fsVizRaf = null, fadeTimeout = null;
        let isFs = false, userBgOverride = null, wakeLock = null;
        const preselected = document.getElementById('gba-noise-select')?.value || 'white';
        let activeNoise = NOISES.find(n => n.id === preselected) || NOISES[0];
        const playerCard = $('gba-player-card');
        const vizLabelEl = $('gba-viz-label');
        const colorNative = $('gba-color-native');
        const hexInput = $('gba-hex-input');
        const swatchBtn = $('gba-swatch-btn');
        const colorDot = $('gba-noise-color-dot');

        // ── Wake Lock ─────────────────────────────────────────────────
        async function requestWakeLock() {
            if (!('wakeLock' in navigator)) return;
            try {
                wakeLock = await navigator.wakeLock.request('screen');
                $('gba-wakelock-badge').classList.add('visible');
                wakeLock.addEventListener('release', () => {
                    wakeLock = null;
                    $('gba-wakelock-badge').classList.remove('visible');
                });
            } catch (e) { }
        }
        function releaseWakeLock() {
            if (wakeLock) { wakeLock.release(); wakeLock = null; }
            $('gba-wakelock-badge').classList.remove('visible');
        }
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible' && playing) requestWakeLock();
        });

        // ── Couleur fond ──────────────────────────────────────────────
        function isLight(hex) {
            const h = hex.replace('#', '');
            const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
            return (r * 299 + g * 587 + b * 114) / 1000 > 145;
        }
        function hexToRgba(hex, a) {
            const h = hex.replace('#', '');
            const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
            return `rgba(${r},${g},${b},${a})`;
        }
        function getActiveBg() { return userBgOverride || activeNoise.bgColor; }

        function applyBg(hex, updateInputs = true) {
            playerCard.style.background = hex;
            vizLabelEl.style.color = isLight(hex) ? 'rgba(0,0,0,.55)' : 'rgba(255,255,255,.65)';
            swatchBtn.style.background = hex;
            // Les swatches sont gérés par updateSwatchActive() via activePaletteIdx
            if (updateInputs) {
                colorNative.value = /^#[0-9a-fA-F]{6}$/.test(hex) ? hex : '#000000';
                hexInput.value = hex.toUpperCase();
            }
            if (isFs) {
                $('gba-viz-fs-overlay').style.background = hex;
            }
        }
        function setAuto() { userBgOverride = null; applyBg(activeNoise.bgColor); }
        function setManualBg(hex) { if (!/^#[0-9a-fA-F]{6}$/.test(hex)) return; userBgOverride = hex; applyBg(hex); }

        colorNative.addEventListener('input', e => setManualBg(e.target.value));
        hexInput.addEventListener('input', e => { let v = e.target.value.trim(); if (!v.startsWith('#')) v = '#' + v; setManualBg(v); });
        hexInput.addEventListener('paste', e => {
            e.preventDefault();
            let v = (e.clipboardData || window.clipboardData).getData('text').trim();
            if (!v.startsWith('#')) v = '#' + v;
            if (/^#[0-9a-fA-F]{6}$/.test(v)) { hexInput.value = v.toUpperCase(); setManualBg(v); }
        });
        $('gba-copy-hex-btn').addEventListener('click', () => {
            navigator.clipboard.writeText(hexInput.value).then(() => {
                $('gba-copy-hex-btn').textContent = '✓'; $('gba-copy-hex-btn').classList.add('copied');
                setTimeout(() => { $('gba-copy-hex-btn').textContent = '⎘'; $('gba-copy-hex-btn').classList.remove('copied'); }, 1500);
            });
        });
        $('gba-auto-btn').addEventListener('click', setAuto);

        // ── Build UI ──────────────────────────────────────────────────
        function buildNamedPresets() {
            const row = $('gba-named-presets-row');
            if (!row) return;
            NAMED_PRESETS.forEach(preset => {
                const btn = document.createElement('button');
                btn.className = 'gba-named-preset-btn';
                btn.dataset.name = preset.name;
                btn.textContent = preset.name;
                btn.addEventListener('click', () => applyNamedPreset(preset));
                row.appendChild(btn);
            });
        }

        function applyNamedPreset(preset) {
            activeNamedPreset = preset.name;
            $$('.gba-named-preset-btn').forEach(b => b.classList.toggle('active', b.dataset.name === preset.name));
            const noise = NOISES.find(n => n.id === preset.noise);
            if (!noise) return;
            selectNoise(noise, false);
            const volSlider = $('gba-volume');
            volSlider.value = preset.volume;
            $('gba-vol-val').textContent = `${preset.volume}%`;
            if (gainNode && !fadeTimeout) gainNode.gain.value = preset.volume / 100;
            applyEQPreset(preset.eq);
            startNoise(noise);
        }

        function hexToHsl(hex) {
            const h = hex.replace('#', '');
            let r = parseInt(h.slice(0, 2), 16) / 255, g = parseInt(h.slice(2, 4), 16) / 255, b = parseInt(h.slice(4, 6), 16) / 255;
            const max = Math.max(r, g, b), min = Math.min(r, g, b);
            let hh = 0, s = 0, l = (max + min) / 2;
            if (max !== min) {
                const d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch (max) {
                    case r: hh = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
                    case g: hh = ((b - r) / d + 2) / 6; break;
                    case b: hh = ((r - g) / d + 4) / 6; break;
                }
            }
            return [hh * 360, s * 100, l * 100];
        }
        function hslToHex(h, s, l) {
            s /= 100; l /= 100;
            const k = n => (n + h / 30) % 12;
            const a = s * Math.min(l, 1 - l);
            const f = n => Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))));
            return '#' + [f(0), f(8), f(4)].map(v => v.toString(16).padStart(2, '0')).join('');
        }

        function generatePalette(baseHex) {
            const [h, s, l] = hexToHsl(baseHex);
            // Cas spécial : blanc ou quasi-blanc → palette monochrome
            if (l >= 95) {
                return new Array(7).fill('#ffffff');
            }
            const base = l > 85 ? 85 : l; // ← décale la base pour le blanc
            const palette = [];
            // 3 tons sombres
            [-9, -6, -3].forEach(delta => {
                palette.push(hslToHex(h, s, Math.max(10, base + delta)));
            });
            // Couleur de base
            palette.push(baseHex);
            // 3 tons clairs
            [3, 6, 9].forEach(delta => {
                palette.push(hslToHex(h, s, Math.min(78, base + delta)));
            });
            return palette;
        }
        let activePaletteIdx = 3; // index 3 = couleur de base par défaut

        function buildPresets() {
            const wrap = $('gba-preset-swatches');
            wrap.innerHTML = '';
            const baseHex = activeNoise.bgColor;
            const palette = generatePalette(baseHex);
            activePaletteIdx = 3; // reset sur la base
            palette.forEach((hex, idx) => {
                const s = document.createElement('button');
                s.className = 'gba-preset-swatch';
                s.dataset.hex = hex;
                s.dataset.idx = idx;
                s.style.background = hex;
                if (idx < 3) s.title = `Ton sombre ${3 - idx} — ${hex.toUpperCase()}`;
                else if (idx === 3) s.title = `Base — ${hex.toUpperCase()}`;
                else s.title = `Ton clair ${idx - 3} — ${hex.toUpperCase()}`;
                s.addEventListener('click', () => {
                    activePaletteIdx = idx;
                    setManualBg(hex);
                    updateSwatchActive();
                });
                wrap.appendChild(s);
            });
            updateSwatchActive();
        }

        function updateSwatchActive() {
            $$('.gba-preset-swatch').forEach(el => {
                const active = parseInt(el.dataset.idx) === activePaletteIdx;
                el.classList.toggle('active', active);
                el.style.boxShadow = active ? '0 0 0 2px #fff, 0 0 0 4px rgba(0,0,0,.3)' : '';
            });
        }

        function buildEQ() {
            const grid = $('gba-eq-grid');
            EQ_BANDS.forEach((band, i) => {
                const col = document.createElement('div');
                col.className = 'gba-eq-band';
                col.innerHTML = `
                    <label>${band.label}</label>
                    <input type="range" id="gba-eq-${i}" min="-12" max="12" step="1" value="0" orient="vertical"/>
                    <span class="gba-eq-val" id="gba-eq-val-${i}">0dB</span>`;
                grid.appendChild(col);
                col.querySelector(`#gba-eq-${i}`).addEventListener('input', e => {
                    $(`gba-eq-val-${i}`).textContent = `${e.target.value}dB`;
                    if (eqNodes[i]) eqNodes[i].gain.value = parseFloat(e.target.value);
                });
            });
            const resetRow = document.createElement('div');
            resetRow.className = 'gba-eq-reset-row';
            const resetBtn = document.createElement('button');
            resetBtn.className = 'gba-eq-reset-btn';
            resetBtn.textContent = '↺ Réinitialiser EQ';
            resetBtn.addEventListener('click', () => applyEQPreset(new Array(EQ_BANDS.length).fill(0)));
            resetRow.appendChild(resetBtn);
            grid.appendChild(resetRow);
        }

        // ── Select bruit ──────────────────────────────────────────────
        function initNoiseSelect() {
            const sel = $('gba-noise-select');
            // sel.value = activeNoise.id;
            updateColorDot();
            sel.addEventListener('change', e => {
                activeNamedPreset = null;
                $$('.gba-named-preset-btn').forEach(b => b.classList.remove('active'));
                const noise = NOISES.find(n => n.id === e.target.value);
                if (noise) selectNoise(noise);
            });
        }

        function updateColorDot() {
            if (colorDot) colorDot.style.background = activeNoise.color;
        }

        // ── EQ preset ─────────────────────────────────────────────────
        function applyEQPreset(values) {
            values.forEach((val, i) => {
                const slider = $(`gba-eq-${i}`);
                const label = $(`gba-eq-val-${i}`);
                if (slider) slider.value = val;
                if (label) label.textContent = `${val}dB`;
                if (eqNodes[i]) eqNodes[i].gain.value = val;
            });
        }

        // ── Audio ─────────────────────────────────────────────────────
        function initAudio() {
            if (audioCtx) return;
            audioCtx = new (window.AudioContext || window.webkitAudioContext)();
            gainNode = audioCtx.createGain();
            gainNode.gain.value = parseInt($('gba-volume').value) / 100;
            eqNodes = EQ_BANDS.map((band, i) => {
                const f = audioCtx.createBiquadFilter();
                f.type = i === 0 ? 'lowshelf' : i === EQ_BANDS.length - 1 ? 'highshelf' : 'peaking';
                f.frequency.value = band.freq; f.gain.value = 0; return f;
            });
            analyser = audioCtx.createAnalyser(); analyser.fftSize = 1024;
            eqNodes.forEach((_, i) => { if (i > 0) eqNodes[i - 1].connect(eqNodes[i]); });
            eqNodes[eqNodes.length - 1].connect(analyser);
            analyser.connect(gainNode);
            gainNode.connect(audioCtx.destination);
            EQ_BANDS.forEach((_, i) => {
                const slider = $(`gba-eq-${i}`);
                if (slider && eqNodes[i]) eqNodes[i].gain.value = parseFloat(slider.value);
            });
        }

        function buildBuffer(noise) {
            const sr = audioCtx.sampleRate;
            const buf = audioCtx.createBuffer(1, sr * 4, sr);
            noise.generate(buf.getChannelData(0), sr); return buf;
        }

        function startNoise(noise) {
            stopNoiseImmediate(); initAudio();
            if (audioCtx.state === 'suspended') audioCtx.resume();
            const src = audioCtx.createBufferSource();
            src.buffer = buildBuffer(noise); src.loop = true;
            src.connect(eqNodes[0]); src.start();
            sourceNode = src;
            const targetVol = parseInt($('gba-volume').value) / 100;
            gainNode.gain.cancelScheduledValues(audioCtx.currentTime);
            gainNode.gain.setValueAtTime(0, audioCtx.currentTime);
            gainNode.gain.linearRampToValueAtTime(targetVol, audioCtx.currentTime + 1.5);
            playing = true; updatePlayUI(); requestWakeLock();
        }

        function stopNoiseImmediate() {
            if (fadeTimeout) { clearTimeout(fadeTimeout); fadeTimeout = null; }
            if (gainNode && audioCtx) {
                gainNode.gain.cancelScheduledValues(audioCtx.currentTime);
                gainNode.gain.setValueAtTime(gainNode.gain.value, audioCtx.currentTime);
            }
            if (sourceNode) { try { sourceNode.disconnect(); sourceNode.stop(); } catch (e) { } sourceNode = null; }
        }

        function stopNoise(withFade = false) {
            if (!sourceNode && !playing) return;
            const fadeDur = withFade ? (parseInt($('gba-fade-select').value) || 0) : 0;
            const targetVol = parseInt($('gba-volume').value) / 100;
            if (fadeDur > 0 && gainNode && audioCtx) {
                gainNode.gain.cancelScheduledValues(audioCtx.currentTime);
                gainNode.gain.setValueAtTime(gainNode.gain.value, audioCtx.currentTime);
                gainNode.gain.linearRampToValueAtTime(0, audioCtx.currentTime + fadeDur);
                fadeTimeout = setTimeout(() => {
                    fadeTimeout = null;
                    if (sourceNode) { try { sourceNode.disconnect(); sourceNode.stop(); } catch (e) { } sourceNode = null; }
                    if (gainNode) gainNode.gain.value = targetVol;
                    playing = false; updatePlayUI(); releaseWakeLock();
                }, fadeDur * 1000 + 150);
            } else {
                stopNoiseImmediate();
                if (gainNode) gainNode.gain.value = targetVol;
                playing = false; updatePlayUI(); releaseWakeLock();
            }
        }

        function selectNoise(n, autoEq = true) {
            activeNoise = n;
            // ✅ Sync le select
            const sel = $('gba-noise-select');
            if (sel) sel.value = n.id;
            updateColorDot();
            vizLabelEl.textContent = `${n.emoji}  ${n.name} — ${n.desc}`;
            userBgOverride = null; // Réinitialise la couleur perso au changement de bruit
            applyBg(n.bgColor);
            buildPresets(); // Regénère la palette selon la couleur du bruit
            if (autoEq) {
                const preset = EQ_PRESETS[n.id];
                if (preset) applyEQPreset(preset);
            }
            if (playing) startNoise(n);
        }

        // ── Visualizer ────────────────────────────────────────────────
        const vizCanvas = $('gba-viz-canvas');
        const vctx = vizCanvas.getContext('2d');

        function resizeMainViz() {
            const dpr = window.devicePixelRatio || 1;
            vizCanvas.width = vizCanvas.clientWidth * dpr;
            vizCanvas.height = vizCanvas.clientHeight * dpr;
        }
        function darken(hex, f) {
            const h = hex.replace('#', '');
            return '#' + [0, 2, 4].map(i => Math.round(parseInt(h.slice(i, i + 2), 16) * f).toString(16).padStart(2, '0')).join('');
        }
        function luminance(hex) {
            const h = hex.replace('#', '');
            const r = parseInt(h.slice(0, 2), 16) / 255, g = parseInt(h.slice(2, 4), 16) / 255, b = parseInt(h.slice(4, 6), 16) / 255;
            const toL = c => c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
            return 0.2126 * toL(r) + 0.7152 * toL(g) + 0.0722 * toL(b);
        }
        function contrastRatio(hex1, hex2) {
            const l1 = luminance(hex1), l2 = luminance(hex2);
            return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
        }
        function getBarColor(bgHex, noiseColor) {
            // Si le contraste entre la couleur du bruit et le fond est suffisant (>= 3), on l'utilise
            if (contrastRatio(bgHex, noiseColor) >= 3) {
                return isLight(bgHex) ? darken(noiseColor, 0.55) : noiseColor;
            }
            // Sinon on choisit blanc ou noir selon la luminosité du fond
            return isLight(bgHex) ? '#1a1a1a' : '#ffffff';
        }
        function getGlowColor(bgHex, noiseColor) {
            if (contrastRatio(bgHex, noiseColor) >= 3) return noiseColor;
            return isLight(bgHex) ? '#333333' : '#eeeeee';
        }
        function renderViz(ctx, W, H) {
            const bg = getActiveBg(), light = isLight(bg);
            ctx.fillStyle = hexToRgba(bg, .35); ctx.fillRect(0, 0, W, H);
            const barColor = getBarColor(bg, activeNoise.color);
            const glowColor = getGlowColor(bg, activeNoise.color);
            if (analyser && playing) {
                const freq = new Uint8Array(analyser.frequencyBinCount);
                analyser.getByteFrequencyData(freq);
                const bars = 64, bw = W / bars;
                for (let i = 0; i < bars; i++) {
                    const idx = Math.floor(i / bars * freq.length * .65);
                    const v = freq[idx] / 255, bh = v * H * .88;
                    // Barre principale avec opacité garantie lisible
                    ctx.fillStyle = hexToRgba(barColor, 0.55 + v * 0.45);
                    ctx.fillRect(i * bw + 1, H - bh, bw - 2, bh);
                    // Ligne de crête en haut de la barre
                    ctx.fillStyle = hexToRgba(glowColor, 0.85);
                    ctx.fillRect(i * bw + 1, H - bh - 2, bw - 2, 2);
                }
            } else {
                const t = Date.now() / 1000;
                ctx.beginPath();
                ctx.strokeStyle = hexToRgba(barColor, light ? 0.75 : 0.70);
                ctx.lineWidth = (window.devicePixelRatio || 1) * 2;
                for (let x = 0; x < W; x++) {
                    const y = H / 2 + Math.sin(x / W * Math.PI * 6 + t) * H * .17;
                    x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
                }
                ctx.stroke();
            }
        }
        function startMainViz() { if (!mainVizRaf) drawMainViz(); }
        function stopMainViz() { }
        function drawMainViz() {
            renderViz(vctx, vizCanvas.width, vizCanvas.height);
            mainVizRaf = requestAnimationFrame(drawMainViz);
        }

        // ── Fullscreen visu ───────────────────────────────────────────
        const vizFsOverlay = $('gba-viz-fs-overlay');
        const vizFsInner = $('gba-viz-fs-inner');
        const vizCanvasFs = $('gba-viz-canvas-fs');
        const fsCtx = vizCanvasFs.getContext('2d');

        function resizeFsViz() {
            const dpr = window.devicePixelRatio || 1;
            vizCanvasFs.width = vizCanvasFs.clientWidth * dpr;
            vizCanvasFs.height = vizCanvasFs.clientHeight * dpr;
        }
        function drawFsViz() { renderViz(fsCtx, vizCanvasFs.width, vizCanvasFs.height); fsVizRaf = requestAnimationFrame(drawFsViz); }
        function openFs() {
            isFs = true;
            const bg = getActiveBg();
            vizFsOverlay.style.background = bg;
            vizFsOverlay.classList.add('open');
            const el = vizFsOverlay;
            if (el.requestFullscreen) el.requestFullscreen();
            else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
            else if (el.mozRequestFullScreen) el.mozRequestFullScreen();
            else if (el.msRequestFullscreen) el.msRequestFullscreen();
        }
        function closeFs() {
            isFs = false; vizFsOverlay.classList.remove('open');
            if (fsVizRaf) { cancelAnimationFrame(fsVizRaf); fsVizRaf = null; }
            if (document.fullscreenElement) document.exitFullscreen();
            else if (document.webkitFullscreenElement) document.webkitExitFullscreen();
            else if (document.mozFullScreenElement) document.mozCancelFullScreen();
            else if (document.msFullscreenElement) document.msExitFullscreen();
        }

        $('gba-viz-fs-btn').addEventListener('click', openFs);
        vizFsOverlay.addEventListener('click', closeFs);
        // Gérer la sortie native du fullscreen (touche Échap du navigateur)
        document.addEventListener('fullscreenchange', () => { if (!document.fullscreenElement && isFs) closeFs(); });
        document.addEventListener('webkitfullscreenchange', () => { if (!document.webkitFullscreenElement && isFs) closeFs(); });
        document.addEventListener('mozfullscreenchange', () => { if (!document.mozFullScreenElement && isFs) closeFs(); });

        // ── Minuterie ─────────────────────────────────────────────────
        function clearTimer() { clearInterval(timerInterval); timerInterval = null; $('gba-timer-row').style.display = 'none'; }
        function cancelTimer() { clearTimer(); $('gba-timer-select').value = '0'; }
        function startTimer(s) {
            clearTimer(); if (s <= 0) return;
            timerRemaining = s; $('gba-timer-row').style.display = 'flex';
            updateTimerDisplay();
            timerInterval = setInterval(() => { timerRemaining--; updateTimerDisplay(); if (timerRemaining <= 0) { clearTimer(); stopNoise(true); } }, 1000);
        }
        function updateTimerDisplay() {
            const h = Math.floor(timerRemaining / 3600), m = Math.floor((timerRemaining % 3600) / 60), s = timerRemaining % 60;
            $('gba-timer-display').textContent =
                h > 0 ? `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
                    : `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
        }

        function updatePlayUI() {
            const pb = $('gba-play-btn'), sb = $('gba-stop-btn');
            pb.textContent = playing ? '▶ En lecture…' : '▶ Écouter';
            pb.disabled = playing; sb.disabled = !playing;
        }

        // ── Events ────────────────────────────────────────────────────
        $('gba-play-btn').addEventListener('click', () => {
            startNoise(activeNoise);
            const secs = parseInt($('gba-timer-select').value) || 0;
            if (secs > 0) startTimer(secs);
        });
        $('gba-stop-btn').addEventListener('click', () => { cancelTimer(); stopNoise(true); });
        $('gba-cancel-timer-btn').addEventListener('click', cancelTimer);
        $('gba-timer-select').addEventListener('change', () => {
            clearTimer();
            const secs = parseInt($('gba-timer-select').value) || 0;
            if (secs > 0 && playing) startTimer(secs);
        });
        $('gba-volume').addEventListener('input', e => {
            const v = parseInt(e.target.value) / 100;
            $('gba-vol-val').textContent = `${e.target.value}%`;
            if (gainNode && !fadeTimeout) gainNode.gain.value = v;
        });

        new ResizeObserver(() => { resizeMainViz(); if (isFs) resizeFsViz(); }).observe(ROOT);

        // ── Init ──────────────────────────────────────────────────────
        buildNamedPresets();
        buildPresets();
        buildEQ();
        initNoiseSelect();
        resizeMainViz();
        applyBg(activeNoise.bgColor);
        startMainViz();
        vizLabelEl.textContent = `${activeNoise.emoji}  ${activeNoise.name} — ${activeNoise.desc}`;
        updatePlayUI();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
}());